import { Check } from 'lucide-react';
import Reveal from './Reveal';
import { IMAGES, ABOUT } from '../lib/site';

const AboutImage = () => (
  <Reveal className="order-2 lg:order-1">
    <div className="relative">
      <div className="overflow-hidden">
        <img
          src={IMAGES.about}
          alt="Energy infrastructure at night"
          className="w-full h-[420px] lg:h-[540px] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/60 via-transparent to-transparent" />
      </div>
      <div className="absolute -left-4 top-10 bottom-10 w-px bg-gradient-to-b from-transparent via-[#00E5FF]/60 to-transparent" />
    </div>
  </Reveal>
);

const AboutPoints = () => (
  <div className="mt-10 space-y-5">
    {ABOUT.points.map((point, i) => (
      <Reveal
        key={point}
        delay={0.18 + i * 0.08}
        className="flex items-start gap-4"
        data-testid={`about-point-${i}`}
      >
        <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center border border-[#00E5FF]/40 text-[#00E5FF]">
          <Check size={11} strokeWidth={3} />
        </span>
        <span className="font-body text-[15px] text-[#CBD5E1] leading-relaxed">{point}</span>
      </Reveal>
    ))}
  </div>
);

export default function About() {
  return (
    <section id="about" className="bg-[#050B14] py-28 lg:py-36" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <AboutImage />

        <div className="order-1 lg:order-2">
          <Reveal>
            <span className="font-body text-[11px] font-semibold uppercase tracking-[0.25em] text-[#00E5FF]">
              {ABOUT.overline}
            </span>
            <span className="line-electric mt-3 mb-6 block" />
          </Reveal>

          <Reveal delay={0.06}>
            <h2
              className="font-display font-semibold text-white leading-[1.1] whitespace-pre-line"
              style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)' }}
              data-testid="about-headline"
            >
              {ABOUT.headline}
            </h2>
          </Reveal>

          <Reveal delay={0.12}>
            <p className="mt-7 font-body text-base md:text-lg text-[#94A3B8] leading-relaxed font-light">
              {ABOUT.body}
            </p>
          </Reveal>

          <AboutPoints />
        </div>
      </div>
    </section>
  );
}
